// extracted by mini-css-extract-plugin
export default {"root":"ShoesBlock_root__ObYeC","title":"ShoesBlock_title__Bi7Kz","shoesFlexBlock":"ShoesBlock_shoesFlexBlock__f31CM"};